import { httpsCallable, getFunctions } from 'firebase/functions';
import app from '../config/firebase';

const functions = getFunctions(app!);

export const callCreateCheckout = async (payload: {
  productId: 'vetaxis'|'staffaxis'|'noteaxis'|'suite';
  planId: string;
  quantity?: number;
}) => {
  const fn = httpsCallable(functions, 'createCheckout');
  const res = await fn(payload);
  return res.data as { actionUrl: string; fields: Record<string,string> };
};

export const callMintProductToken = async (payload: { productId: 'vetaxis'|'staffaxis'|'noteaxis'; password?: string }) => {
  const fn = httpsCallable(functions, 'mintProductToken');
  const res = await fn(payload);
  return res.data as { token: string; redirectUrl: string };
};

export const callSyncMyEntitlementsFromPayments = async () => {
  const fn = httpsCallable(functions, 'syncMyEntitlementsFromPayments');
  const res = await fn({});
  return res.data as {
    ok: boolean;
    updated: Array<{ productId: string; plan: string; status: string; paymentId?: string | null }>;
  };
};

const PLAN_CATALOG_CACHE_KEY = 'bioaxis_plan_catalog_v1';
const PLAN_CATALOG_CACHE_TTL_MS = 10 * 60 * 1000;

export type PlanCatalog = Awaited<ReturnType<typeof callGetPlanCatalog>>;

export const readCachedPlanCatalog = (): PlanCatalog | null => {
  try {
    const raw = sessionStorage.getItem(PLAN_CATALOG_CACHE_KEY);
    if (!raw) return null;
    const { at, data } = JSON.parse(raw);
    if (typeof at !== 'number' || Date.now() - at > PLAN_CATALOG_CACHE_TTL_MS) return null;
    return data as PlanCatalog;
  } catch {
    return null;
  }
};

export const callGetPlanCatalog = async () => {
  const fn = httpsCallable(functions, 'getPlanCatalog');
  const res = await fn({});
  try {
    sessionStorage.setItem(PLAN_CATALOG_CACHE_KEY, JSON.stringify({ at: Date.now(), data: res.data }));
  } catch {}
  return res.data as {
    vetaxis: Array<{
      id: string;
      name: string;
      description: string;
      price: number;
      order: number;
      active: boolean;
      features?: string[] | Record<string, unknown>;
      limits?: string[] | Record<string, unknown>;
      tags?: string[];
    }>;
    staffaxis: Array<{
      id: string;
      name: string;
      description: string;
      price: number;
      order: number;
      active: boolean;
      features?: string[] | Record<string, unknown>;
      limits?: string[] | Record<string, unknown>;
      tags?: string[];
    }>;
    noteaxis: Array<{
      id: string;
      name: string;
      description: string;
      price: number;
      order: number;
      active: boolean;
      features?: string[] | Record<string, unknown>;
      limits?: string[] | Record<string, unknown>;
      tags?: string[];
    }>;
    suite: Array<{ id: string; name: string; description: string; order: number; includes: Record<string, number>; active: boolean }>;
  };
};

export const callEnsureSuitePlans = async () => {
  const fn = httpsCallable(functions, 'ensureSuitePlans');
  const res = await fn({});
  return res.data as { ok: boolean };
};

export const callGrantDevEntitlement = async (payload: { productId: 'vetaxis'|'staffaxis'|'noteaxis'; planId: string; status?: 'active'|'trialing' }) => {
  const fn = httpsCallable(functions, 'grantDevEntitlement');
  const res = await fn(payload);
  return res.data as { ok: boolean };
};
